const SET_USUARIO = (state, logged) => {
	state.logged = logged
}

const SET_MENU = (state, menu) => {
	state.menu = menu
}

const SET_JWT = (state, jwt) => {
	state.jwt = jwt
}

const SET_ACESSO_MODULO = (state, acesso_modulo) => {
	state.acesso_modulo = acesso_modulo
}

const SET_ACESSO_PERMISSAO = (state, acesso_permissao) => {
	state.acesso_permissao = acesso_permissao
}

export{
	SET_USUARIO,
	SET_MENU,
	SET_ACESSO_MODULO,
	SET_ACESSO_PERMISSAO,
	SET_JWT
}



// WEBPACK FOOTER //
// ./src/store/usuario/mutations.js